import React from "react";
import VerifyLinkContainer from "containers/VerifyLink";
const VerifyLink = (props) => {
    return (<>
        <VerifyLinkContainer />
    </>);
}

export default VerifyLink;